var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid app_container"},[_c('NavBar'),_c('HeroSection'),_c('HowItWorks'),_c('OurServices'),_c('Portfolio'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }